import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/PrintWorkingSetSpecificationsWizard.scss';
import autobind from 'autobind-decorator';
import PrintIcon from '../assets/images/print-60x60.svg';
import {
  __,
  getActiveStage,
  mapStateToProps,
  validateForm,
} from '../core/utils';
import * as _ from 'lodash';
import PrintWorkingSetSpecificationsForm from '../forms/print_working_set_specifications_wizard/PrintWorkingSetSpecificationsForm';
import { setNotification } from '../redux/actions/general/notification';
import { printWorkingSetSpecifications } from '../redux/actions/table/working_set_specifications';
import moment from 'moment';

@mapStateToProps((state) => ({
  specifications: _.get(
    state.table,
    'working_set_specifications.print_specifications_wizard'
  ),
  project_language: _.get(
    state.table,
    'working_set_specifications.project_language'
  ),
  specification_ids: _.get(
    state.table,
    'working_set_specifications.specification_ids'
  ),
  print_specifications_source: _.get(
    state.table,
    'working_set_specifications.print_specifications_source'
  ),
}))
class PrintWorkingSetSpecificationsWizard extends Component {
  @autobind
  _handleSubmit(formData) {
    const { specification_ids } = this.props;

    formData = _.omit(formData, ['print_specifications_source']);

    if (formData.date) {
      formData = {
        ...formData,
        date: moment.utc(formData.date).clone().local().format('YYYY-MM-DD'),
      };
    }

    return validateForm(
      printWorkingSetSpecifications(
        getActiveStage(),
        formData.specifications == 'print_all' ? null : specification_ids,
        formData
      ).then(() => {
        setNotification(
          __(
            'specifications.working-set.notification.working-set-specification-pdf-generation-start.notification-download-link'
          )
        );

        this.props.onClose();
      })
    );
  }

  render() {
    const { specifications, specification_ids } = this.props;

    return (
      <>
        <div className={styles.header}>
          <div className={styles.left}>
            <span>
              {__('specifications.working-set.flyout.print.pdf-settings')}
            </span>
            <span>
              {__(
                'specifications.working-set.flyout.print.choose-options-specifications-pdf'
              )}
            </span>
          </div>
          <div className={styles.right}>
            <PrintIcon />
          </div>
        </div>
        <div className={styles.body}>
          <PrintWorkingSetSpecificationsForm
            onSubmit={this._handleSubmit}
            initialValues={{
              cover: _.size(specifications) > 1 ? 1 : 0,
              contents_simple: _.size(specifications) > 1 ? 1 : 0,
              contents_detailed: _.size(specifications) > 1 ? 1 : 0,
              header: 1,
              footer: 1,
              model: 1,
              manufacturer: 1,
              representative: 1,
              //print_linked_specifications: 1,
              language_id: this.props.project_language,
              date: moment().startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
              specifications,
              specification_ids,
              print_specifications_source:
                this.props.print_specifications_source,
              print_specification_quantities: 1,
              hide_specification_quantities: 0,
            }}
          />
        </div>
      </>
    );
  }
}

export default PrintWorkingSetSpecificationsWizard;
